jQuery.noConflict();
(function($){
//SlickHeader
$(function() {
	$('#SlickHeader').slick({
		fade: false,
		swipe: false,
		arrows: false,
		dots: true,
		dotsClass: 'slick-dots',
		infinite: true,
		speed: 1000,
		//slidesToShow: 3,
		slidesToScroll: 1,
		centerMode: true, //要素を中央寄せ
		centerPadding: '25%',
		autoplay: true, //自動再生
		autoplaySpeed: 2500, //自動再生のスピード
		responsive: [{
			breakpoint: 600,
			settings: {
				swipe: true,
				centerMode: false,
				slidesToShow: 1,
				slidesToScroll: 1,
			}
		}]
	});
});
//SlickFooter
$(function() {
	$('#SlickFooter').slick({
		fade: false,
		swipe: false,
		arrows: true,
		dots: false,
		infinite: true,
		speed: 1000,
		slidesToShow: 3,
		slidesToScroll: 1,
		centerMode: false, //要素を中央寄せ
		autoplay: true, //自動再生
		autoplaySpeed: 2500, //自動再生のスピード
		responsive: [{
			breakpoint: 600,
			settings: {
				swipe: true,
				centerMode: true,
				slidesToShow: 1,
				slidesToScroll: 1,
			}
		}]
	});
});
}(jQuery));